import SocialCampaignTypeToken from '@apps/campaigns/admin/tokens/social_campaign_type'
import MJSONScreenshot from '@admin/components/mjson_screenshot'
import Button from '@admin/components/button'
import Image from '@admin/components/image'
import PropTypes from 'prop-types'
import Edit from '../edit'
import React from 'react'

class UnscheduledToken extends React.PureComponent {

  static contextTypes = {
    flash: PropTypes.object,
    provider: PropTypes.object
  }

  static propTypes = {
    social_campaign: PropTypes.object,
    onEdit: PropTypes.func
  }

  tokenRef = React.createRef()
  previewRef = React.createRef()

  _handleEdit = this._handleEdit.bind(this)
  _handleDragStart = this._handleDragStart.bind(this)

  render() {
    const { social_campaign } = this.props
    const variant = social_campaign.variants?.[0]
    const thumbnail = variant ? this._getThumbnail(variant) : null
    return (
      <div { ...this._getToken() }>
        <Button { ...this._getInner() }>
          <div className="campaign-token-preview" ref={ this.previewRef }>
            <div className="campaign-token-preview-inner">
              { thumbnail ? (
                <Image { ...thumbnail } />
              ) : variant ? (
                <MJSONScreenshot { ...this._getScreenshot(variant) } />
              ) : null }
            </div>
          </div>
          <div className="campaign-token-label">
            <div className="token-link">
              { social_campaign.title }
            </div>
            <SocialCampaignTypeToken social_campaign={ social_campaign } />
          </div>          
        </Button>
        <Button { ...this._getEdit() } />
      </div>
    )
  }

  _getInner() {
    return {
      className: 'campaign-token-inner',
      handler: this._handleEdit,
      context_menu: {
        tasks: this._getTasks()
      }
    }
  }

  _getEdit() {
    return {
      svg: 'ellipsis_vertical',
      className: 'campaign-token-action',
      tasks: this._getTasks()
    }
  }

  _getScreenshot(entity) {
    return {
      engine: 'mjson',
      entity: `campaigns_social_campaign_variants/${entity.code}`,
      width: 100,
      height: 75,
      screenshoted_at: entity.screenshoted_at,
      updated_at: entity.updated_at
    }
  }

  _getThumbnail(variant) {
    if(variant.thumbnail) {
      const isVideo = variant.thumbnail.content_type?.startsWith('video/')
      return {
        src: isVideo ? variant.thumbnail.preview : variant.thumbnail.path,
        transforms: { fit: 'cover', w: 100, h: 100 }
      }
    }
    if(variant.video) {
      return {
        src: variant.video.preview,
        transforms: { fit: 'cover', w: 100, h: 100 }
      }
    }
    return null
  }

  _getTasks() {
    const { social_campaign } = this.props
    return [
      { 
        label: 't(Manage Social Campaign)', 
        svg: 'settings',
        route: `/admin/campaigns/social/${social_campaign.id}` 
      },
      { 
        label: social_campaign.status === 'scheduled' ? 't(Unschedule Social Campaign)' : 't(Schedule Social Campaign)', 
        svg: 'clock',
        modal: <Edit social_campaign={ social_campaign } /> 
      },
      {
        label: 't(Delete Social Campaign)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this social campaign? You will also delete all of the associated workflows and performance data)',
        request: {
          endpoint: `/api/admin/campaigns/social/${social_campaign.id}`,
          method: 'DELETE',
          onFailure: () => this.context.flash.set('error', 't(Unable to delete social campaign)')
        }
      }
    ]
  }

  _getToken() {
    const { social_campaign } = this.props
    return {
      ref: this.tokenRef,
      className: 'campaign-token compact',
      draggable: true,
      title: social_campaign.title,
      onClick: this._handleEdit,
      onDragStart: this._handleDragStart
    }
  }

  _handleDragStart(e) {
    const { social_campaign } = this.props
    e.stopPropagation()
    e.dataTransfer.effectAllowed = 'move'
    e.dataTransfer.setData('social_campaign', JSON.stringify(social_campaign))
    if(this.previewRef.current) {
      const size = 200
      const clone = this.previewRef.current.cloneNode(true)
      Object.assign(clone.style, {
        width: `${size}px`,
        height: `${size}px`,
        position: 'fixed',
        top: '-9999px',
        left: '-9999px',
        borderRadius: '0',
        overflow: 'hidden'
      })
      const img = clone.querySelector('img')
      if(img) {
        Object.assign(img.style, {
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        })
      }
      document.body.appendChild(clone)
      e.dataTransfer.setDragImage(clone, size / 2, size / 2)
      setTimeout(() => document.body.removeChild(clone), 0)
    }
  }

  _handleEdit() {
    const { social_campaign } = this.props
    this.props.onEdit(social_campaign)
  }

}

export default UnscheduledToken
